import { Icon, IconButton, Menu, MenuItem, Tooltip } from "@material-ui/core";
import { useSnackbar } from "notistack";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import DenseAppBar from "../../components/AppBar";
import Filters from "../../components/Filters";
import AlertModal from "../../components/Modal";
import PaginationControlled from "../../components/Pagination";
import Placeholder from "../../components/Skeleton";
import { getCurrency, getDateTime } from "../../helpers/Functions";
import { Reducers } from "../../Interfaces/Interfaces";
import { getAgents } from "../../redux/actions/AgentActions";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import {
  getCoordinatorDashboard,
  getTransactionDashboard,
} from "../../redux/actions/DashboardActions";
import {
  transactionTypes,
  getTransactions,
  getTransactionSummary,
  reconfirmTransactions,
  getCoordinatorTransactions,
  getTransactionByUser,
  sendReconfirmTransactions,
  sendReconfirmTransactionPage,
} from "../../redux/actions/TransactionActions";
import PrimaryTheme from "../../Themes/Primary";
import "./transaction.scss";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import { getCoordinatorTransactionDashboard } from "../../redux/actions/CoordinatorActions";
import { useEffect } from "react";
export default function Transactions() {
  const alert = useSelector((state: Reducers) => state.alert);
  const user = useSelector((state: Reducers) => state.user);

  const transactions = useSelector((state: Reducers) => state.transactions);
  const types = useSelector((state: Reducers) => state.transactionTypes);
  const agents = useSelector((state: Reducers) => state.agents);
  const userType = useSelector((state: Reducers) => state.userType);
  const dashboard = useSelector(
    (state: Reducers) => state.transactionDashboard
  );
  const transactionDetailsMessageReducer = useSelector(
    (state: any) => state.transactionDetailsMessageReducer
  );
  // const coordinatorType = useSelector((state: Reducers) => state.coordinatorType);

  const dispatch = useDispatch();
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();

  const [searchState, setSearchState] = React.useState("");
  const [state, setState] = React.useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    },
  ]);

  const [page, setPage] = React.useState(0);
  const [pageSize, setPageSize] = React.useState(10);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [typeState, setTypeStateChange] = React.useState(0);
  const [amount, setAmount] = React.useState("");
  const [exportAmount, setExportAmount] = React.useState("");
  const [transactionStatus, setTransactionStatus] = React.useState(0);
  const [agent, setAgent] = React.useState("");
  const [agentId, setAgentId] = React.useState("");
  const [phone, setPhone] = React.useState("");
  const [reference, setReference] = React.useState("");
  const [type, setType] = React.useState("0");
  const [startDate, setStartDate] = React.useState("");
  const [endDate, setEndDate] = React.useState("");
  const [submitted, setSubmitted] = React.useState(false);
  const [ClickDownload, setClickDownload] = React.useState(false);
  const [clearAgentDropdown, setclearAgentDropdown] = React.useState(false);
  const [canDownloadReports, setCanDownloadReports] = React.useState(
    user.permission && user.permission.canDownloadReports
  );
  let list = transactions && transactions.items;

  let agentList: Array<any> = agents && agents.items;
  // console.log({agentList});
  let filter: any = {};
  const paginationConfig = {
    page: page + 1,
    pageSize,
    id: user.id,
    whereCondition: JSON.stringify(filter),
  };

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleReconfirm = (ref: any, transactionType: any) => {
    setAnchorEl(null);
    const data = {
      ref,
      transactionType,
    };

    dispatch(sendReconfirmTransactionPage(data));

    dispatch({
      type: "LOADING",
      payload: true,
    });
  };

  const handleDownload = () => {
    // setSubmitted(true);

    if (agentId.length !== 0) {
      filter.agent = agentId;
    }

    if (phone.length !== 0) {
      filter.phoneNumber = phone;
    }

    if (exportAmount.length !== 0) {
      filter.amount = exportAmount;
    }

    if (reference.length !== 0) {
      filter.reference = reference;
    }

    if (type !== "0") {
      filter.transactionType = type;
    }

    if (endDate.length !== 0) {
      filter.dateCreatedFrom = startDate;
    }
    if (startDate.length !== 0) {
      filter.dateCreatedTo = endDate;
    }

    window.open(
      `https://transactions-${
        process.env.REACT_APP_STAGE
      }-alb.bankly.ng/api/transaction/downloadAggregatorReport/${
        user.id
      }/${JSON.stringify(filter)}`,
      "_blank"
    );
  };
  const handleAgentSearch = (value: any) => {
    setclearAgentDropdown(true);
    setAgent(value);
  };
  React.useEffect(() => {
    if (agent.length > 3) {
      filter.name = agent;

      const paginationConfig1 = {
        page: page + 1,
        pageSize: agents.total,
        id: user.id,
        whereCondition: JSON.stringify(filter),
      };
      dispatch({ type: "LOADING", payload: true });
      dispatch(getAgents(paginationConfig1));
    }
  }, [agent, agentId]);

  const handleSelectAgent = (agentName: any, agentId: any) => {
    setAgent(agentName);
    setAgentId(agentId);
    setclearAgentDropdown(false);
  };

  const reset = () => {
    setAgent("");
    setExportAmount("");
    setPhone("");
    setReference("");
    setType("0");
    setStartDate("");
    setEndDate("");
    setSubmitted(false);
  };

  const callTransactions = () => {
    dispatch(getTransactions(paginationConfig));
    dispatch(getTransactionSummary(user.id));
  };

  const handleSelect = (date: any) => {
    setState([date.selection]);

    filter.dateCreatedFrom = date.selection.startDate;
    filter.dateCreatedTo = date.selection.endDate;
    paginationConfig.whereCondition = JSON.stringify(filter);

    // dispatch({ type: "LOADING", payload: true });
    callTransactions();
  };

  const getIndexSeed = (index: number) => {
    paginationConfig.page = page + 1;
    return (paginationConfig.page - 1) * paginationConfig.pageSize + index + 1;
  };

  const handleChange = (event: React.ChangeEvent<unknown>, value: number) => {
    setPage(value);
  };

  const handlePageSizeChange = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    value: any
  ) => {
    setPageSize(value.props.value);
    dispatch({ type: "LOADING", payload: true });
    paginationConfig.pageSize = value.props.value;
    callTransactions();
  };

  const handleRefresh = () => {
    dispatch({
      type: "LOADING",
      payload: true,
    });
    callTransactions();
  };

  const handleClear = () => {
    filter = {};
    paginationConfig.whereCondition = JSON.stringify(filter);

    setAmount("");
    setTypeStateChange(0);
    setTransactionStatus(0);
    setSearchState("");

    dispatch({
      type: "LOADING",
      payload: true,
    });

    // dispatch(getPOSDashboard(user.id));
    callTransactions();
  };
  const handleSearch = (e: string) => {
    filter.parentReference = e;
    paginationConfig.whereCondition = JSON.stringify(filter);
    callTransactions();
  };
  React.useEffect(() => {
    if (typeState !== 0) {
      filter.transactionType = typeState;
      paginationConfig.whereCondition = JSON.stringify(filter);

      dispatch({ type: "LOADING", payload: true });
    }
    if (transactionStatus !== 0) {
      filter.statusId = transactionStatus;
      paginationConfig.whereCondition = JSON.stringify(filter);

      dispatch({ type: "LOADING", payload: true });
    }
    if (amount !== "") {
      filter.amount = amount;
      paginationConfig.whereCondition = JSON.stringify(filter);

      dispatch({ type: "LOADING", payload: true });
    }

    if (searchState.length >= 3) {
      //filter.name = searchState;
      paginationConfig.whereCondition = JSON.stringify(filter);

      dispatch({ type: "LOADING", payload: true });
    }
    callTransactions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [typeState, transactionStatus, amount, searchState]);

  React.useEffect(() => {
    dispatch({ type: "TRANSACTION_DETAILS_MESSAGE", payload: { message: {} } });
    dispatch({ type: "ALERT_MODAL", payload: false });
    dispatch({
      type: "LOADING",
      payload: true,
    });

    callTransactions();
    // dispatch(getTransactionSummary(user.id));
    dispatch(transactionTypes());
    dispatch(getAgents(paginationConfig));

    return () => {
      dispatch({
        type: "TRANSACTIONS",
        payload: {},
      });
      dispatch({
        type: "DASHBOARD",
        payload: {},
      });
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, page]);

  React.useEffect(() => {
    if (Object.entries(alert).length !== 0) {
      if (!alert.successful) {
        // display error message
        enqueueSnackbar(alert.message, { variant: "error" });

        dispatch({
          type: "LOADING",
          payload: false,
        });

        dispatch({
          type: "ALERT",
          payload: {},
        });
      } else {
        // enqueueSnackbar(alert.message, { variant: "success" });

        dispatch({
          type: "LOADING",
          payload: false,
        });

        dispatch({
          type: "ALERT",
          payload: {},
        });
      }

      // console.log({message:})
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, enqueueSnackbar, alert, history]);

  React.useEffect(() => {
    if (transactionDetailsMessageReducer.message) {
      setClickDownload(false);
      dispatch({ type: "ALERT_MODAL", payload: true });
    } else {
      setClickDownload(true);
      dispatch({ type: "ALERT_MODAL", payload: false });
    }
  }, [transactionDetailsMessageReducer]);
  const handleDownloadButton = () => {
    setClickDownload(true);
    dispatch({
      type: "ALERT_MODAL",
      payload: true,
    });
  };

  return (
    <React.Fragment>
      <div
        className="col-md-11 mr-auto ml-auto p-0"
        style={{
          height: "auto",
          position: "relative",
        }}
      >
        <DenseAppBar />
      </div>
      <div
        className="col-md-12 pl-0 pr-0"
        style={{
          // overflow: "auto",
          backgroundColor: PrimaryTheme.white,
          // height: '100vh',
        }}
      >
        <div
          className="col-md-11 ml-auto mr-auto p-0"
          style={{
            backgroundColor: PrimaryTheme.white,
            height: "100vh",
            position: "relative",
          }}
        >
          <h1
            className="mb-5 transaction-header"
            style={{
              fontFamily: PrimaryTheme.fonts?.MediumFont,
              textTransform: "uppercase",
              fontSize: PrimaryTheme.fontSizes?.subtitle,
            }}
          >
            Agent Transactions
          </h1>

          {/* cards  */}
          <div className="row mb-5">
            <div
              className="col-md col-6"
              style={{
                height: "auto",
                position: "relative",
                textAlign: "center",
              }}
            >
              <h5
                className="text-uppercase"
                style={{
                  color: PrimaryTheme.primary,
                }}
              >
                Total
              </h5>
              <h3
                className="text-uppercase text-bold mb-0"
                style={{
                  color: PrimaryTheme.dark,
                  fontFamily: PrimaryTheme.fonts?.MediumFont,
                }}
              >
                {dashboard && dashboard.totalTransactions
                  ? (dashboard.totalTransfers+dashboard.totalPosCashWithdrawal+dashboard.totalDeposit+dashboard.totalBillPayments)
                  : 0}
              </h3>
              <h6
                className="text-uppercase"
                style={{
                  color: PrimaryTheme.primary,
                }}
              >
                {dashboard && dashboard.transactionValue
                  ? getCurrency(dashboard.transferVolume+dashboard.posCashWithdrawalVolume+dashboard.depositVolume+dashboard.billPaymentVolume)
                  : 0}
              </h6>
            </div>

            <div
              className="col-md col-6"
              style={{
                height: "auto",
                position: "relative",
                textAlign: "center",
              }}
            >
              <h5
                className="text-uppercase"
                style={{
                  color: PrimaryTheme.primary,
                }}
              >
                Transfers
              </h5>
              <h3
                className="text-uppercase text-bold mb-0"
                style={{
                  color: PrimaryTheme.dark,
                  fontFamily: PrimaryTheme.fonts?.MediumFont,
                }}
              >
                {dashboard && dashboard.totalTransfers
                  ? dashboard.totalTransfers
                  : 0}
              </h3>
              <h6
                className="text-uppercase"
                style={{
                  color: PrimaryTheme.primary,
                }}
              >
                {dashboard && dashboard.transferVolume
                  ? getCurrency(dashboard.transferVolume)
                  : 0}
              </h6>
            </div>

            <div
              className="col-md col-6"
              style={{
                height: "auto",
                position: "relative",
                textAlign: "center",
              }}
            >
              <h5
                className="text-uppercase"
                style={{
                  color: PrimaryTheme.primary,
                }}
              >
                Pos Withdraw
              </h5>
              <h3
                className="text-uppercase text-bold mb-0"
                style={{
                  color: PrimaryTheme.dark,
                  fontFamily: PrimaryTheme.fonts?.MediumFont,
                }}
              >
                {dashboard && dashboard.totalPosCashWithdrawal
                  ? dashboard.totalPosCashWithdrawal
                  : 0}
              </h3>
              <h6
                className="text-uppercase"
                style={{
                  color: PrimaryTheme.primary,
                }}
              >
                {dashboard && dashboard.posCashWithdrawalVolume
                  ? getCurrency(dashboard.posCashWithdrawalVolume)
                  : 0}
              </h6>
            </div>

            <div
              className="col-md col-6"
              style={{
                height: "auto",
                position: "relative",
                textAlign: "center",
              }}
            >
              <h5
                className="text-uppercase"
                style={{
                  color: PrimaryTheme.primary,
                }}
              >
                Savings
              </h5>
              <h3
                className="text-uppercase text-bold mb-0"
                style={{
                  color: PrimaryTheme.dark,
                  fontFamily: PrimaryTheme.fonts?.MediumFont,
                }}
              >
                {dashboard && dashboard.totalDeposit
                  ? dashboard.totalDeposit
                  : 0}
              </h3>
              <h6
                className="text-uppercase"
                style={{
                  color: PrimaryTheme.primary,
                }}
              >
                {dashboard && dashboard.depositVolume
                  ? getCurrency(dashboard.depositVolume)
                  : 0}
              </h6>
            </div>

            <div
              className="col-md col-6"
              style={{
                height: "auto",
                textAlign: "center",
                position: "relative",
              }}
            >
              <h5
                className="text-uppercase"
                style={{
                  color: PrimaryTheme.primary,
                }}
              >
                Bills
              </h5>
              <h3
                className="text-uppercase text-bold mb-0"
                style={{
                  color: PrimaryTheme.dark,
                  fontFamily: PrimaryTheme.fonts?.MediumFont,
                }}
              >
                {dashboard
                  ? dashboard.totalBillPayments
                    ? dashboard.totalBillPayments
                    : "0"
                  : 0}
              </h3>
              <h6
                className="text-uppercase"
                style={{
                  color: PrimaryTheme.primary,
                }}
              >
                {dashboard
                  ? dashboard.billPaymentVolume === 0
                    ? "0"
                    : getCurrency(dashboard.billPaymentVolume)
                    ? getCurrency(dashboard.billPaymentVolume)
                    : "0"
                  : "0"}
              </h6>
            </div>
          </div>

          {userType === "5" || canDownloadReports ? (
            <div className="row mb-5">
              <div className="col-md-12">
                <Filters
                  name="Download Transactions"
                  hasDownloads
                  onDownload={handleDownloadButton}
                  hasSearch
                  onClear={handleClear}
                  searchState={searchState}
                  isTransaction
                  typeItems={types}
                  typeState={typeState}
                  handleSearch={(e: any) => handleSearch(e.target.value)}
                  onTypeChange={(e: any) => setTypeStateChange(e.target.value)}
                  handleSelect={(item: any) => handleSelect(item)}
                  ranges={state}
                  amount={amount}
                  amountChange={(e: any) => setAmount(e.target.value)}
                  transactionStatus={transactionStatus}
                  transactionStatusChange={(e: any) =>
                    setTransactionStatus(e.target.value)
                  }
                />
              </div>
            </div>
          ) : (
            ""
          )}

          <div className="row">
            <div className="col-md-12 mb-3" style={{ paddingBottom: "150px" }}>
              {list ? (
                <React.Fragment>
                  <div className="table-responsive">
                    <table className="table table-hover">
                      <thead className="thead-primary">
                        <tr className="text-center">
                          <th scope="col">S/N</th>
                          <th scope="col">Type</th>
                          <th scope="col">Date</th>
                          <th scope="col">Sender</th>
                          <th scope="col">Receiver</th>
                          <th scope="col">Reference</th>
                          <th scope="col">Amount</th>
                          <th scope="col">Charges</th>
                          <th scope="col">Commission</th>
                          <th scope="col">Status</th>
                          <th scope="col">Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {list.length !== 0 &&
                          list?.map((item: any, index: number) => (
                            <tr key={index} className="text-center pointer">
                              <th scope="row">{getIndexSeed(index)}</th>
                              <td>
                                <div className="row m-0 justify-content-start align-items-center">
                                  {(item.transactionType === 1 ||
                                    item.transactionType === 3) && (
                                    <Icon
                                      fontSize="small"
                                      style={{
                                        color: PrimaryTheme.lightGreen,
                                        marginRight: 5,
                                      }}
                                    >
                                      fiber_manual_record
                                    </Icon>
                                  )}
                                  {item.transactionType === 4 && (
                                    <Icon
                                      fontSize="small"
                                      style={{
                                        color: PrimaryTheme.lightGreen,
                                        marginRight: 5,
                                      }}
                                    >
                                      fiber_manual_record
                                    </Icon>
                                  )}
                                  {item.transactionType === 5 && (
                                    <Icon
                                      fontSize="small"
                                      style={{
                                        color: PrimaryTheme.lightGreen,
                                        marginRight: 5,
                                      }}
                                    >
                                      fiber_manual_record
                                    </Icon>
                                  )}
                                  {item.transactionType === 2 && (
                                    <Icon
                                      fontSize="small"
                                      style={{
                                        color: PrimaryTheme.info,
                                        marginRight: 5,
                                      }}
                                    >
                                      fiber_manual_record
                                    </Icon>
                                  )}

                                  {item.transactionType === 22 && (
                                    <Icon
                                      fontSize="small"
                                      style={{
                                        color: PrimaryTheme.lightGreen,
                                        marginRight: 5,
                                      }}
                                    >
                                      fiber_manual_record
                                    </Icon>
                                  )}
                                  {item.transactionTypeName}
                                </div>
                              </td>
                              <td>{getDateTime(item.transactionDate)}</td>
                              <td>{item.senderName ?? item.sender}</td>
                              <td>{item.receiverName ?? item.receiver}</td>
                              <td>{item.parentReference}</td>
                              <td>
                                {item.amount
                                  ? getCurrency(item.amount)
                                  : getCurrency("0")}
                              </td>
                              <td>
                                {item.charges
                                  ? getCurrency(item.charges)
                                  : getCurrency("0")}
                              </td>
                              <td>
                                {item.aggregatorCommission
                                  ? getCurrency(item.aggregatorCommission)
                                  : getCurrency("0")}
                              </td>
                              {/* <td>{item.aggregatorCommission ? getCurrency(item.aggregatorCommission) : "-"}</td> */}
                              <td>
                                {item.status === 1 && (
                                  <span className="badge badge-pill badge-warning p-2 pl-3 pr-3 mr-1">
                                    {item.statusName}
                                  </span>
                                )}
                                {item.status === 2 && (
                                  <span className="badge badge-pill badge-danger p-2 pl-3 pr-3 mr-1">
                                    {item.statusName}
                                  </span>
                                )}
                                {item.status === 3 && (
                                  <span className="badge badge-pill badge-success p-2 pl-3 pr-3 mr-1">
                                    {item.statusName}
                                  </span>
                                )}

                                {/* <IconButton size="small" aria-controls={index + "simple-menu"} aria-haspopup="true" onClick={handleClick}>
                                <Icon style={{
                                  color: PrimaryTheme.light,
                                }}>more_vert</Icon>
                              </IconButton> */}

                                {/* <Menu
                                id={index + "simple-menu"}
                                anchorEl={anchorEl}
                                // keepMounted
                                open={Boolean(anchorEl)}
                                onClose={() => setAnchorEl(null)}
                              >
                                <MenuItem onClick={() => history.push(`/transactions/details/${item.id}`)} style={{
                                  fontSize: 14
                                }}> <Icon fontSize="small" className="mr-2">visibility</Icon> View Details</MenuItem>
                                <MenuItem onClick={() => handleReconfirm(item.parentReference)} style={{
                                  fontSize: 14
                                }}> <Icon fontSize="small" className="mr-2">refresh</Icon> Reconfirm</MenuItem>
                              </Menu> */}
                              </td>

                              <td style={{ display: "flex" }}>
                                <Tooltip title="View">
                                  <IconButton
                                    size="small"
                                    style={{
                                      marginRight: 5,
                                      marginLeft: 5,
                                    }}
                                    onClick={() =>
                                      history.push(
                                        `/transactions/details/${item.id}`
                                      )
                                    }
                                  >
                                    <Icon
                                      style={{
                                        color: PrimaryTheme.light,
                                      }}
                                    >
                                      visibility
                                    </Icon>
                                  </IconButton>
                                </Tooltip>

                                {item.transactionType === 4 ? (
                                  <Tooltip title="Reconfirm">
                                    <IconButton
                                      size="small"
                                      style={{
                                        marginRight: 5,
                                        marginLeft: 5,
                                      }}
                                      onClick={() =>
                                        handleReconfirm(
                                          item.parentReference,
                                          item.transactionType
                                        )
                                      }
                                    >
                                      <Icon
                                        style={{
                                          color: PrimaryTheme.success,
                                        }}
                                      >
                                        refresh
                                      </Icon>
                                    </IconButton>
                                  </Tooltip>
                                ) : (
                                  <Tooltip title="Reconfirm">
                                    <IconButton
                                      size="small"
                                      style={{
                                        marginRight: 5,
                                        marginLeft: 5,
                                      }}
                                    >
                                      <Icon
                                        style={{
                                          color: PrimaryTheme.success,
                                        }}
                                      >
                                        refresh
                                      </Icon>
                                    </IconButton>
                                  </Tooltip>
                                )}
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>

                  {list.length === 0 && (
                    <React.Fragment>
                      <p className="text-center mt-3 text-dark w-100">
                        No result
                      </p>
                    </React.Fragment>
                  )}

                  <div className="col-md-12 p-0">
                    {transactions.total > pageSize && (
                      <PaginationControlled
                        onPageSizeChange={handlePageSizeChange}
                        onChange={handleChange}
                        page={page}
                        total={transactions.total && transactions.total}
                        pageSize={pageSize}
                      />
                    )}
                  </div>
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <div className="col-md-12 text-center">
                    <Placeholder
                      variant="text"
                      width={"100%"}
                      height={50}
                      animation="wave"
                      className="display-inline"
                    />
                  </div>
                  <div className="col-md-12 text-center">
                    <Placeholder
                      variant="text"
                      width={"100%"}
                      height={50}
                      animation="wave"
                      className="display-inline"
                    />
                  </div>
                  <div className="col-md-12 text-center">
                    <Placeholder
                      variant="text"
                      width={"100%"}
                      height={50}
                      animation="wave"
                      className="display-inline"
                    />
                  </div>
                </React.Fragment>
              )}
            </div>
          </div>
        </div>
        {ClickDownload === false ? (
          <AlertModal showClose>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                paddingTop: "50px",
                paddingBottom: "50px",
              }}
            >
              <div style={{ textAlign: "center", width: "90%" }}>
                <div style={{ marginBottom: "30px" }}>
                  <CheckCircleIcon
                    style={{ fontSize: "80px", color: "green" }}
                  />
                </div>

                {transactionDetailsMessageReducer.message}
              </div>
            </div>
          </AlertModal>
        ) : (
          ""
        )}
        {ClickDownload === true ? (
          <AlertModal showClose maxWidth="md">
            <div className="col-md-12 pl-5 pr-5 pb-5 text-center">
              <div className="col-md-12">
                <span
                  className="badge-pill p-3 d-block col-7 ml-auto mr-auto"
                  style={{
                    background: PrimaryTheme.warn,
                    fontFamily: PrimaryTheme.fonts?.MediumFont,
                  }}
                >
                  Download Transactions
                </span>
              </div>

              {/* <p className="mt-3 mb-5" style={{
     fontFamily: PrimaryTheme.fonts?.RegularFont,
     fontSize: 14,
     color: PrimaryTheme.light
   }}>{subtitle}</p> */}

              <div className="row m-0">
                <div className="col-md-3">
                  <div className="form-group mt-4 text-left">
                    <label
                      htmlFor="agent"
                      style={{
                        fontFamily: PrimaryTheme.fonts?.MediumFont,
                        color: PrimaryTheme.dark,
                      }}
                    >
                      Agent
                    </label>
                    <input
                      type="text"
                      placeholder="Agent Name"
                      autoComplete="text"
                      id="agent"
                      value={agent}
                      inputMode="text"
                      onChange={(e) => handleAgentSearch(e.target.value)}
                      className="form-control"
                      style={{
                        fontFamily: PrimaryTheme.fonts?.RubikLight,
                        color: PrimaryTheme.dark,
                        // background: "#F4F7FC"
                      }}
                    />

                    <div>
                      {clearAgentDropdown ? (
                        <div
                          style={{
                            marginTop: "10px",
                            cursor: "pointer",
                            marginBottom: "10px",
                          }}
                        >
                          {" "}
                          {agent.length > 3 ? (
                            <div>
                              {" "}
                              {agentList &&
                                agentList.length !== 0 &&
                                agentList.map((item: any, index: number) => (
                                  <li
                                    key={index}
                                    onClick={() =>
                                      handleSelectAgent(item.name, item.id)
                                    }
                                  >
                                    {item.name}
                                  </li>
                                ))}
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                    {/* <select className="custom-select" id="agent" name="agent" value={agent} onChange={(e) => setAgent(e.target.value)}>
           <option value="0">Select Agent</option>
           {agentList && agentList.length !== 0 && agentList.map((item: any, index: number) => (
             <option key={index} value={item.id}>{item.name}</option>
           ))}
         </select> */}
                  </div>
                </div>

                <div className="col-md-3">
                  <div className="form-group mt-4 text-left">
                    <label
                      htmlFor="phone"
                      style={{
                        fontFamily: PrimaryTheme.fonts?.MediumFont,
                        color: PrimaryTheme.dark,
                      }}
                    >
                      Phone Number
                    </label>
                    <input
                      type="tel"
                      placeholder="Phone Number"
                      autoComplete="text"
                      id="phone"
                      value={phone}
                      inputMode="text"
                      onChange={(e) => setPhone(e.target.value)}
                      className="form-control"
                      style={{
                        fontFamily: PrimaryTheme.fonts?.RubikLight,
                        color: PrimaryTheme.dark,
                        // background: "#F4F7FC"
                      }}
                    />
                  </div>
                </div>

                <div className="col-md-3">
                  <div className="form-group mt-4 text-left">
                    <label
                      htmlFor="amount"
                      style={{
                        fontFamily: PrimaryTheme.fonts?.MediumFont,
                        color: PrimaryTheme.dark,
                      }}
                    >
                      Amount
                    </label>
                    <input
                      type="number"
                      placeholder="Amount"
                      id="amount"
                      value={exportAmount}
                      inputMode="text"
                      onChange={(e) => setExportAmount(e.target.value)}
                      className="form-control"
                      style={{
                        fontFamily: PrimaryTheme.fonts?.RubikLight,
                        color: PrimaryTheme.dark,
                        // background: "#F4F7FC"
                      }}
                    />
                  </div>
                </div>

                <div className="col-md-3">
                  <div className="form-group mt-4 text-left">
                    <label
                      htmlFor="reference"
                      style={{
                        fontFamily: PrimaryTheme.fonts?.MediumFont,
                        color: PrimaryTheme.dark,
                      }}
                    >
                      Transaction Reference
                    </label>
                    <input
                      type="tel"
                      placeholder="Reference"
                      id="reference"
                      value={reference}
                      inputMode="text"
                      onChange={(e) => setReference(e.target.value)}
                      className="form-control"
                      style={{
                        fontFamily: PrimaryTheme.fonts?.RubikLight,
                        color: PrimaryTheme.dark,
                        // background: "#F4F7FC"
                      }}
                    />
                  </div>
                </div>

                <div className="col-md-3">
                  <div className="form-group mt-4 text-left">
                    <label
                      htmlFor="type"
                      style={{
                        fontFamily: PrimaryTheme.fonts?.MediumFont,
                        color: PrimaryTheme.dark,
                      }}
                    >
                      Transaction Type
                    </label>
                    <select
                      className="custom-select"
                      id="type"
                      name="type"
                      value={type}
                      onChange={(e) => setType(e.target.value)}
                    >
                      <option value="0">Select Type</option>
                      {types.length !== 0 &&
                        types.map((type: any, index: number) => (
                          <option key={index} value={type.id}>
                            {type.name}
                          </option>
                        ))}
                    </select>
                  </div>
                </div>

                <div className="col-md-3">
                  <div className="form-group mt-4 text-left">
                    <label
                      htmlFor="startDate"
                      style={{
                        fontFamily: PrimaryTheme.fonts?.MediumFont,
                        color: PrimaryTheme.dark,
                      }}
                    >
                      Start Date
                    </label>
                    <input
                      type="date"
                      placeholder="Amount"
                      id="startDate"
                      value={startDate}
                      onChange={(e) => setStartDate(e.target.value)}
                      className="form-control"
                      style={{
                        fontFamily: PrimaryTheme.fonts?.RubikLight,
                        color: PrimaryTheme.dark,
                        // background: "#F4F7FC"
                      }}
                    />
                  </div>
                </div>

                <div className="col-md-3">
                  <div className="form-group mt-4 text-left">
                    <label
                      htmlFor="endDate"
                      style={{
                        fontFamily: PrimaryTheme.fonts?.MediumFont,
                        color: PrimaryTheme.dark,
                      }}
                    >
                      End Date
                    </label>
                    <input
                      type="date"
                      placeholder="Amount"
                      id="endDate"
                      value={endDate}
                      onChange={(e) => setEndDate(e.target.value)}
                      className="form-control"
                      style={{
                        fontFamily: PrimaryTheme.fonts?.RubikLight,
                        color: PrimaryTheme.dark,
                        // background: "#F4F7FC"
                      }}
                    />
                  </div>
                </div>

                <div className="col-md-12 text-right">
                  <button
                    className="btn btn-light mr-1"
                    type="reset"
                    onClick={reset}
                  >
                    Reset
                  </button>
                  <button
                    disabled={submitted || startDate === "" || endDate === ""}
                    onClick={handleDownload}
                    className="btn btn-success"
                  >
                    {submitted ? "Downloading..." : "Download"}
                  </button>
                </div>
              </div>
            </div>
          </AlertModal>
        ) : (
          ""
        )}
      </div>
    </React.Fragment>
  );
}
